/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used for the Optimization capability.
 * @export
 */
export const OPTIMIZATION_CAPABILITY_STRINGS = {
  altTitle: `optimization`,
  dialogBlurb: `Offers tools that help you refine result pages for the best search user experience.`,
  dialogBullet1: `Feature content from other sources using best bets.`,
  dialogBullet2: `Control how some queries are interpreted to match up with your organization's terminology.`,
  dialogBullet3: `Customize result pages for specific queries.`,
  subtitle: `Audit, view analytics, and improve user journeys.`,
  title: `Optimization`,
};
